import React from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { COLORS } from "../../lib/colors";

import classes from "./index.module.scss";
import "./style.scss";
import { styled } from "@mui/material/styles";
// import Stack from "@mui/material/Stack";

const CustomButton = styled(Button)((props) => ({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  padding: "6px 12px",
  width: props.width,
  fullWidth: props.fullWidth,
  minHeight: "50px",
  // border: "none",
  lineHeight: 1.5,
  backgroundColor: props.backgroundColor || COLORS.purple,
  color: props.textColor || COLORS.white,
  // borderColor: "#0063cc",
  borderRadius: "6px",
  fontFamily: [
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  "&:hover": {
    backgroundColor: COLORS.yellow,
    // borderColor: "#0062cc",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: COLORS.yellow,

    // borderColor: "#005cbf",
  },
  "&:focus": {},
}));

function Index(props) {
  return (
    // <Stack>
    <CustomButton
      variant="contained"
      backgroundColor={props.backgroundColor}
      textColor={props.textColor}
      startIcon={props.icon}
      className={`${props.className} ${classes.btnComponent}`}
      onClick={props.onClick}
      disabled={props.disabled}
      width={props.width}
      fullWidth={props.fullWidth}
      // loading={props.loading || false}
    >
      {props.loading === true ? <CircularProgress /> : props.children}
    </CustomButton>
    // </Stack>
  );
}

export default Index;
